import Q7BankruptcyDischarge from './Q7BankruptcyDischarge';
export default Q7BankruptcyDischarge;